import React from 'react';
import Slider from 'react-slick';
import { mediaType } from '../../libs/typeInterface';

interface IBigSlider {
  settingsMain: {};
  // tslint:disable-next-line: no-any
  setSlider1: (x: any) => void;
  // tslint:disable-next-line: no-any
  nav2: any;
  media: mediaType[];
  name: string;
  setShowZoomModal: (x: boolean) => void;
  setInitialImage: (x: mediaType) => void;
}

const BigSlider = (props: IBigSlider) => {
  const { settingsMain, setSlider1, nav2, media, name, setShowZoomModal, setInitialImage } = props;

  return (
    <>
      <Slider
        className="lg:h-full w-full slider-for"
        {...settingsMain}
        // @ts-ignore
        asNavFor={nav2}
        ref={(slider) => setSlider1(slider)}
      >
        {media.map((item, index) => (
          <div key={index} className="h-full">
            <div className="xs:hidden w-full h-full lg:flex items-center justify-center">
              <img
                style={{ cursor: 'zoom-in' }}
                alt={name + '_' + index}
                src={item.value}
                onClick={() => {
                  setShowZoomModal(true);
                  setInitialImage(media[0]);
                }}
                className="w-full h-full object-contain"
              />
            </div>
            <div className="xs:flex w-full h-full lg:hidden items-center justify-center">
              <img
                alt={name + '_' + index}
                src={item.value}
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        ))}
      </Slider>
    </>
  );
};

export default BigSlider;
